import React, {useEffect} from 'react'

import SearchWidget from '../../../shared/components/SearchWidget';
import HOTEL_RATING_MAP from '../constants/HatelRatingMap';


const Rating = ({ value, onChoose }) => {
    let title = !!value ? HOTEL_RATING_MAP.find(rating => rating.id == value).name : 'Любой рейтинг';
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && title == 'Любой рейтинг') {
        title = 'Любой рейтинг отеля';
    }
    return <SearchWidget
      cssClass="rating"
      type="select"
      label="рейтинг отеля"
      title={title}
      items={HOTEL_RATING_MAP}
      value={value}
      buttonDone={false}
      onChoose={onChoose} />
}
export default Rating;